import { useCallback, useMemo } from 'react'
import { useLocalStorage } from '@/hooks/useLocaleStorage'

function isDateInRange(startDate: Date, endDate: Date) {
  const today = new Date()
  return today >= startDate && today <= endDate
}

export interface BonusGiftType {
  id: string
  startDate: Date
  lastDateToEnter: Date
  winnerAnnouncedDate: Date
  imageUrl: string
  valueInPennies: number
}

const bonusGift: BonusGiftType = {
  id: 'bonus-prize-5',
  startDate: new Date('12/20/2024'),
  lastDateToEnter: new Date('12/22/2024'),
  winnerAnnouncedDate: new Date('12/10/2024'),
  imageUrl: 'https://images.angelstudios.com/image/upload/v1734715952/Homestead/Bonus-Items-w05c.webp',
  valueInPennies: 77300,
}

export const useBonusGift = (theatricalSlug: string) => {
  const { startDate, lastDateToEnter, id } = bonusGift
  const { storedValue: hasSeenBonusGift, setStoredValue, isReady } = useLocalStorage(id, false, 'boolean')

  const isBonusGiftLive = isDateInRange(startDate, lastDateToEnter)
  const setHasSeenBonusGift = useCallback(() => {
    setStoredValue(true)
  }, [setStoredValue])

  return useMemo(() => {
    return {
      bonusGift: theatricalSlug === 'homestead' ? bonusGift : null,
      isBonusGiftLive,
      hasSeenBonusGift,
      setHasSeenBonusGift,
      isReady,
    }
  }, [theatricalSlug, hasSeenBonusGift, isBonusGiftLive, isReady, setHasSeenBonusGift])
}
